import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78f1889f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "srs-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "srs-summary",
  style: { color: '#e8392a' }
}
const _hoisted_3 = { class: "srs-items" }
const _hoisted_4 = { class: "srs-item-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "fi-label-main" }
const _hoisted_7 = {
  key: 0,
  class: "fi-label-sub",
  style: {"color":"#e8392a"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "srs-item-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoardSelectorPopup = _resolveComponent("BoardSelectorPopup")!
  const _component_FactorItem = _resolveComponent("FactorItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangeTree, (group, gi) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.attrCode,
        class: "srs-group"
      }, [
        _createElementVNode("div", {
          class: "srs-group-title",
          style: _normalizeStyle({ color: _ctx.colors.textMuted })
        }, [
          _createTextVNode(_toDisplayString(gi + 1) + "." + _toDisplayString(group.attrName) + " ", 1),
          (_ctx.groupSelectedSummary(group))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.groupSelectedSummary(group)), 1))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.childAttrList, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.attrCode
            }, [
              (_ctx.isBoardItem(item))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["factor-item", { selected: _ctx.boardSelected[item.attrCode]?.length > 0 }]),
                        style: _normalizeStyle(_ctx.tagStyle(_ctx.boardSelected[item.attrCode]?.length > 0)),
                        onClick: ($event: any) => (_ctx.openBoard(item))
                      }, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.attrName), 1),
                        (_ctx.boardSelected[item.attrCode]?.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 已选择" + _toDisplayString(_ctx.boardSelected[item.attrCode].length) + "个" + _toDisplayString(item.attrName), 1))
                          : _createCommentVNode("", true),
                        (_ctx.boardSelected[item.attrCode]?.length)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "fi-remove",
                              onClick: _withModifiers(($event: any) => (_ctx.clearBoard(item.attrCode)), ["stop"])
                            }, "×", 8, _hoisted_8))
                          : _createCommentVNode("", true)
                      ], 14, _hoisted_5)
                    ]),
                    _createVNode(_component_BoardSelectorPopup, {
                      visible: _ctx.boardPopup.itemCode === item.attrCode,
                      title: item.attrName,
                      options: _ctx.boardPopup.options,
                      loading: _ctx.boardPopup.loading,
                      "initial-selected": _ctx.boardSelected[item.attrCode] || [],
                      "is-light": _ctx.isLight,
                      colors: _ctx.colors,
                      onConfirm: ($event: any) => (_ctx.onBoardConfirm(item.attrCode, $event)),
                      onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.boardPopup.itemCode = ''))
                    }, null, 8, ["visible", "title", "options", "loading", "initial-selected", "is-light", "colors", "onConfirm"])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_FactorItem, {
                      factor: _ctx.normalizeItem(item),
                      selected: _ctx.isItemSelected(item),
                      "is-light": _ctx.isLight,
                      colors: _ctx.colors,
                      headers: _ctx.headers,
                      "sub-label": _ctx.getSelectedHint(item),
                      "show-sub-label": true,
                      onToggle: _ctx.onToggle
                    }, null, 8, ["factor", "selected", "is-light", "colors", "headers", "sub-label", "onToggle"])
                  ]))
            ], 64))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}